import './error-table.scss';

import { Col, Popconfirm } from 'antd';
import React, { useState } from 'react';

import ImageComponent from '@sharedComponent/image-component';
// import UploadPayrollPopup from 'src/utils/uploadPayrollPopup';
// import { icons } from '@assets/icons/index';
import { images } from 'src/assets/img';
import { useEffect } from 'react';

export default function ErrorTable({
	data = [
		{
			columnName: 'EmiratesId',
			rowId: [1, 2],
			errorMessage: 'Emirates ID number should begin with 784.',
		},
		{
			columnName: 'EmiratesId',
			rowId: [1, 2],
			errorMessage: "Employee's Date of Birth doesn't match with the Emirates ID number.",
		},
		{
			columnName: 'Iban',
			rowId: [2],
			errorMessage: 'The bank details for the employee will not be considered as you selected C3 as a channel.',
		},
	],
	loadErrorData,
	enableNextButton,
	fromDeletePage = false,
}) {
	const [dataSource, setDataSource] = useState({ tableData: data, expanded: false });
	const [errorCount, setErrorCount] = useState(0);
	const [ignoredData, setIgnoredData] = useState([]);
	const [errordataList, setErrorDataList] = useState([]);
	const [checkList, setCheckList] = useState([]);
	const [visible, setVisible] = useState(false);
	const [isRemove, setIsRemove] = useState(false);
	const [temp, setTemp] = useState(null);
	const [message, setMessage] = useState('');
	const [subMessage, setSubMessage] = useState('');
	const [indexNo, setIndexNo] = useState(null);
	const removeMessage = "This employee will be removed from the file. Please click 'Yes' to confirm.";
	const IgnoreMessage = "This error will be ignored and the employee will be included in the file. Please click 'Yes' to confirm.";

	// console.log('dataSource', dataSource);

	useEffect(() => {
		setDataSource({
			...dataSource,
			tableData: data,
		});
	}, [data]);

	const toggleContent = () => {
		setDataSource({
			...dataSource,
			expanded: !expanded,
		});
	};
	const { tableData, expanded } = dataSource;

	let viewContent = '';
	let slicedData = [];
	if (expanded) {
		viewContent = 'less';
		slicedData = tableData.slice(0, tableData.length);
	} else {
		viewContent = 'all';
		slicedData = tableData.slice(0, 2);
	}

	const autoFixEmployeeFileError = (errorEmployeeObject, index) => {
		if (errorEmployeeObject) {
			let errorData = [];
			let rowId = errorEmployeeObject.rowId;

			if (rowId.length > 1) {
				rowId.forEach((id, index) => {
					errorData.push({
						columnName: errorEmployeeObject.columnName,
						empId: id.toString(),
						rowId: id.toString(),
						error: errorEmployeeObject.errorMessage,
						errorAction: errorEmployeeObject.errorType,
					});
				});

				loadErrorData(errorData);
			} else {
				let singleArrayObject = [];
				singleArrayObject.push({
					columnName: errorEmployeeObject.columnName,
					empId: errorEmployeeObject.rowId[0],
					rowId: errorEmployeeObject.rowId[0],
					error: errorEmployeeObject.errorMessage,
					errorAction: errorEmployeeObject.errorType,
				});
				loadErrorData(singleArrayObject);
			}
			let checkedList = [];
			checkedList = checkList;
			checkedList.push(index);
			setCheckList(checkedList);

			enableButton();
			setVisible(false);
		}
	};

	const enableButton = () => {
		if ([...checkList].length == tableData.length) {
			enableNextButton(true);
		} else {
			enableNextButton(false);
		}
	};
	const closePopup = () => {
		setVisible(false);
	};
	const onConfirm = () => {
		setIsRemove(true);
		setVisible(false);
	};
	const setPopupMessage = (errorType) => {
		if (errorType === 'Remove') {
			setMessage('Remove Employee(s) from File');
			setSubMessage('Do you want to remove employee(s) from the file?');
		} else if (errorType === 'Round-off Decimals') {
			setMessage('Round off decimals?');
			setSubMessage('Your file will be submitted with a maximum of 2 decimals for each salary.');
		} else if (errorType === 'Ignore') {
			setMessage('Ignore error?');
			setSubMessage('The error will be ignored and the employee will be included in the file.');
		} else if (errorType === 'Bank Error') {
			setMessage('Ignore Bank Error?');
			setSubMessage('A C3Pay card will be delivered for this employee.');
		} else if (errorType === 'Remove Bank') {
			setMessage('Ignore Bank Error?');
			setSubMessage('A C3Pay card will be delivered for this employee.');
		} else {
			setMessage('Remove Employee(s) from File');
			setSubMessage('Do you want to remove employee(s) from the file?');
		}
	};
	return (
		<Col xl={24} md={24} lg={24} sm={24} xs={24}>
			<table className="errorTable">
				<thead>
					<tr>
						<th style={{ width: '25%' }}>Column</th>
						<th style={{ width: '25%' }}>Employee ID</th>
						<th style={{ width: '25%' }}>Error</th>
						{!fromDeletePage && <th style={{ display: data.errorType ? 'block' : 'none' }}>Action</th>}
					</tr>
				</thead>
				<tbody>
					{slicedData.map((data, index) => (
						<>
							<tr>
								<td>{data.columnName}</td>
								<td style={{ wordBreak: 'break-word', lineHeight: 1.3 }}>{data?.employeeId?.join()}</td>
								<td style={{ wordBreak: 'break-word', lineHeight: 1.3 }}>{data?.errorMessage}</td>
								{!fromDeletePage && data.errorType && (
									<td style={{ lineHeight: 1.3 }}>
										{data.errorType !== 'Required' ? (
											<button
												style={{
													background: 'transparent',
													border: 'none',
													cursor: data.errorType == 'Required' ? null : 'pointer',

													opacity: checkList.includes(index) === true ? '0.5' : null,
												}}
												className={data.errorType == 'Remove' ? 'btnforpayrollRemove' : 'btnforpayroll'}
												disabled={checkList.includes(index) === true || data.errorType == 'Required' ? true : false}
												onClick={() => {
													setVisible(true);
													setTemp({
														columnName: data.columnName,
														rowId: data.rowId,
														errorMessage: data.errorMessage,
														errorType: data.errorType,
														data: data,
													});
													setPopupMessage(data.errorType);
													setIndexNo(index);
												}}>
												{data.errorType == 'Remove' && checkList.includes(index) == false ? (
													<ImageComponent
														style={{
															marginRight: '10px',
															width: '15px',
															display: 'inline',
															cursor: 'pointer',
															opacity: 'none',
														}}
														src={images.deleteicon}
													/>
												) : null}

												{checkList.includes(index) ? (
													<ImageComponent
														style={{
															marginRight: '10px',
															width: '20px',
															display: 'inline',
															cursor: 'pointer',
															opacity: 'none',
														}}
														src={images.Check}
													/>
												) : // <div style={{ width: '20px', marginRight: '10px' }}></div>
												null}
												{data.errorType == 'Remove' ? `${data.errorType} Employee` : data.errorType}
											</button>
										) : (
											// </Popconfirm>
											'Correct the excel and upload the file again.'
										)}
									</td>
								)}
							</tr>
							{/* <UploadPayrollPopup
								visible={visible}
								closePopup={closePopup}
								autoFixEmployeeFileError={autoFixEmployeeFileError}
								temp={temp}
								index={indexNo}
								message={message}
								subMessage={subMessage}
							/> */}
						</>
					))}
				</tbody>
			</table>
			{tableData.length > 2 && (
				<span className="view-text" onClick={toggleContent}>
					View {viewContent}
				</span>
			)}
		</Col>
	);
}
